import { useProductPageStore } from '../../contexts/ProductPageStore'
import styles from './faqEmbeddedMaker.module.scss'

import React, { useEffect } from 'react'

import ErrorBoundary from 'Clutch/UtilityComponents/ErrorBoundary'

const FaqEmbeddedMaker = () => {
  const faqEmbeddedMaker = useProductPageStore((state) => state.faqEmbeddedMaker)

  useEffect(() => {
    try {
      if (faqEmbeddedMaker) {
        const wrapper = document.querySelector('.faq-maker-wrapper')

        if (wrapper) {
          const existingScript = wrapper.querySelector(`script[src="${faqEmbeddedMaker}"]`)

          if (!existingScript) {
            const script = document.createElement('script')
            script.src = faqEmbeddedMaker
            script.async = true
            wrapper.appendChild(script)

            return () => {
              if (wrapper && script.parentNode === wrapper) {
                wrapper.removeChild(script)
              }
            }
          }
        }
      }
    } catch (err) {
      console.error('Error loading FAQ embedded maker script:', err)
    }
  }, [faqEmbeddedMaker])

  if (!faqEmbeddedMaker) return null

  return (
    <ErrorBoundary>
      <div className={styles.faq_embedded_maker_wrapper}>
        <div className={'faq-maker-wrapper'}></div>
      </div>
    </ErrorBoundary>
  )
}

export default FaqEmbeddedMaker
